import React, { useState, useEffect } from "react";
import { useIntl } from 'react-intl';
import {
	Collapse,
	TextField,
	Grid,
	Box,
} from '@material-ui/core';
import Switch from "react-switch";

const FILTER_STATE_INIT = {
	apellido: '',
	nombre: '',
	legajoNumero: '',
	email: '',
	documentoNumero: '',
	base: '',
	categoria: '',
	perfil: '',
	region: '',
	subregion: '',
	showInactivos: false,
};

const STORAGE_KEY = 'PersonasGrid_filtros';

const readStorage = () => {
	try {
		const saved = localStorage.getItem(STORAGE_KEY);
		if (saved) return JSON.parse(saved);
	} catch (e) {}
	return null;
};

const PersonasGridFiltros = (props) => {
	const intl = useIntl();

	const [showPersistirFiltros, setShowPersistirFiltros] = useState(() => {
		const saved = readStorage();
		return saved && saved.activo === true;
	});

	const [filtersState, setFiltersState] = useState(() => {
		const saved = readStorage();
		if (saved && saved.activo) {
			const { activo, ...filters } = saved;
			return { ...FILTER_STATE_INIT, ...filters };
		}
		return { ...FILTER_STATE_INIT };
	});

	useEffect(() => {
		if (props.filterResetInputs) {
			setFiltersState({ ...FILTER_STATE_INIT });
			if (showPersistirFiltros) {
				localStorage.setItem(STORAGE_KEY, JSON.stringify({ activo: true, ...FILTER_STATE_INIT }));
			}
			props.setFilterResetInputs && props.setFilterResetInputs(false);
		}
	}, [props.filterResetInputs]);

	const triggerFilter = (updatedState) => {
		if (showPersistirFiltros) {
			localStorage.setItem(STORAGE_KEY, JSON.stringify({ activo: true, ...updatedState }));
		}
		props.setFilterQuery({ ...updatedState });
	};

	const handleChange = (name, value) => {
		setFiltersState((prev) => ({ ...prev, [name]: value }));
	};

	const handleBlur = (name, value) => {
		const updated = { ...filtersState, [name]: value };
		triggerFilter(updated);
	};

	const handleOnEnter = (e, name, value) => {
		if (e.keyCode === 13) {
			e.preventDefault();
			handleBlur(name, value);
		}
	};

	const handleSwitch = (name, value) => {
		const updated = { ...filtersState, [name]: value };
		setFiltersState(updated);
		triggerFilter(updated);
	};

	const handlePersistirFiltros = (value) => {
		setShowPersistirFiltros(value);
		if (value) {
			localStorage.setItem(STORAGE_KEY, JSON.stringify({ activo: true, ...filtersState }));
		} else {
			localStorage.removeItem(STORAGE_KEY);
		}
	};

	const { filtersData } = props;
	const bases = (filtersData && filtersData.base) ? filtersData.base : [];
	const categorias = (filtersData && filtersData.categoria) ? filtersData.categoria : [];
	const perfiles = (filtersData && filtersData.perfil) ? filtersData.perfil : [];
	const regiones = (filtersData && filtersData.region) ? filtersData.region : [];
	const subregiones = (filtersData && filtersData.subregion) ? filtersData.subregion : [];

	return (
		<Collapse in={props.dropdownActive}>
			<Grid container item xs={12} spacing={2} style={{ marginBottom: 16, marginTop: 4 }}>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						label={intl.formatMessage({ id: 'personasGrid.filtros.apellido', defaultMessage: 'Apellido' })}
						name="apellido"
						value={filtersState.apellido}
						onChange={(e) => handleChange('apellido', e.target.value)}
						onBlur={(e) => handleBlur('apellido', e.target.value)}
						onKeyDown={(e) => handleOnEnter(e, 'apellido', e.target.value)}
						className="col-12"
					/>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						label={intl.formatMessage({ id: 'personasGrid.filtros.nombre', defaultMessage: 'Nombre' })}
						name="nombre"
						value={filtersState.nombre}
						onChange={(e) => handleChange('nombre', e.target.value)}
						onBlur={(e) => handleBlur('nombre', e.target.value)}
						onKeyDown={(e) => handleOnEnter(e, 'nombre', e.target.value)}
						className="col-12"
					/>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						label={intl.formatMessage({ id: 'personasGrid.filtros.legajo', defaultMessage: 'Legajo' })}
						name="legajoNumero"
						value={filtersState.legajoNumero}
						onChange={(e) => handleChange('legajoNumero', e.target.value)}
						onBlur={(e) => handleBlur('legajoNumero', e.target.value)}
						onKeyDown={(e) => handleOnEnter(e, 'legajoNumero', e.target.value)}
						className="col-12"
					/>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						label={intl.formatMessage({ id: 'personasGrid.filtros.email', defaultMessage: 'Email' })}
						name="email"
						value={filtersState.email}
						onChange={(e) => handleChange('email', e.target.value)}
						onBlur={(e) => handleBlur('email', e.target.value)}
						onKeyDown={(e) => handleOnEnter(e, 'email', e.target.value)}
						className="col-12"
					/>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						label={intl.formatMessage({ id: 'personasGrid.filtros.documento', defaultMessage: 'Nro. Documento' })}
						name="documentoNumero"
						value={filtersState.documentoNumero}
						onChange={(e) => handleChange('documentoNumero', e.target.value)}
						onBlur={(e) => handleBlur('documentoNumero', e.target.value)}
						onKeyDown={(e) => handleOnEnter(e, 'documentoNumero', e.target.value)}
						className="col-12"
					/>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						select
						label={intl.formatMessage({ id: 'personasGrid.filtros.base', defaultMessage: 'Base' })}
						name="base"
						value={filtersState.base}
						onChange={(e) => handleSwitch('base', e.target.value)}
						className="col-12"
						SelectProps={{ native: true }}
					>
						<option value=""></option>
						{bases.map((b) => <option key={b.value} value={b.value}>{b.label}</option>)}
					</TextField>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						select
						label={intl.formatMessage({ id: 'personasGrid.filtros.categoria', defaultMessage: 'Categoría' })}
						name="categoria"
						value={filtersState.categoria}
						onChange={(e) => handleSwitch('categoria', e.target.value)}
						className="col-12"
						SelectProps={{ native: true }}
					>
						<option value=""></option>
						{categorias.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
					</TextField>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						select
						label={intl.formatMessage({ id: 'personasGrid.filtros.perfil', defaultMessage: 'Perfil' })}
						name="perfil"
						value={filtersState.perfil}
						onChange={(e) => handleSwitch('perfil', e.target.value)}
						className="col-12"
						SelectProps={{ native: true }}
					>
						<option value=""></option>
						{perfiles.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
					</TextField>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						select
						label={intl.formatMessage({ id: 'personasGrid.filtros.region', defaultMessage: 'Región' })}
						name="region"
						value={filtersState.region}
						onChange={(e) => handleSwitch('region', e.target.value)}
						className="col-12"
						SelectProps={{ native: true }}
					>
						<option value=""></option>
						{regiones.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
					</TextField>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						select
						label={intl.formatMessage({ id: 'personasGrid.filtros.subregion', defaultMessage: 'Sub-Región' })}
						name="subregion"
						value={filtersState.subregion}
						onChange={(e) => handleSwitch('subregion', e.target.value)}
						className="col-12"
						SelectProps={{ native: true }}
					>
						<option value=""></option>
						{subregiones.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
					</TextField>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2} className="align-self-end" style={{ paddingBottom: 4 }}>
					<div className="d-flex align-items-center" style={{ gap: 8 }}>
						<span style={{ fontSize: 13 }}>
							{intl.formatMessage({ id: 'personasGrid.filtros.ver_inactivos', defaultMessage: 'Ver Inactivos' })}
						</span>
						<Switch
							onChange={(value) => handleSwitch('showInactivos', value)}
							checked={filtersState.showInactivos}
							offColor="#FF4961"
							onColor="#28D094"
						/>
					</div>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2} className="align-self-end" style={{ paddingBottom: 4 }}>
					<div className="d-flex align-items-center" style={{ gap: 8 }}>
						<span style={{ fontSize: 13 }}>
							{intl.formatMessage({ id: 'personasGrid.filtros.persistir_filtros', defaultMessage: 'Persistir Filtros' })}
						</span>
						<Switch
							onChange={(value) => handlePersistirFiltros(value)}
							checked={showPersistirFiltros}
							offColor="#FF4961"
							onColor="#28D094"
						/>
					</div>
				</Grid>
			</Grid>
		</Collapse>
	);
};

export default PersonasGridFiltros;
